export class StripeTokenModel {
  id: string;
  object: string;
  card: StripeCardModel;
  client_ip: string;
  created: number
  livemode: boolean;
  type: string;
  used: boolean
}

export class StripeCardModel {
  id: string;
  object: string;
  address_city: string;
  address_country: string;
  address_line1: string;
  address_line1_check: string;
  address_line2: string;
  address_state: string;
  address_zip: string;
  address_zip_check: string;
  brand: string;
  country: string;
  cvc_check: string;
  dynamic_last4: string;
  exp_month: number;
  exp_year: number;
  funding: string;
  last4: string;
  metadata: {};
  name: string;
  tokenization_method: string;
}

export class StripSubscriptionDetails {
  amount?: number;
  currency?: string;
  connected_account_id?: string;
  automatic_payment_methods?: any;
  payment_method_types?: string[];
  description?: string; // Booked service names / event titles, shown on the Stripe PaymentIntent
  metadata?: {
    // User metadata
    email?: string; // Email
    prename?: string; // Prename
    lastname?: string; // Lastname
    phone?: string; // Phone
    mobile?: string; // Mobile

    // Partner metadata
    partner_id?: number;
    partner_name?: string;

    // Booking metadata (what was paid for)
    widget_type?: string;
    service_names?: string; // Appointment bookings: booked service names, comma separated
    service_ids?: string; // Appointment bookings: booked service ids, comma separated
    event_titles?: string; // Event bookings: booked event titles, comma separated
    event_ids?: string; // Event bookings: booked event ids, comma separated

    // Coupon metadata
    coupon_id?: number; // Coupon ID
    original_amount?: number; // Original amount
    coupon_code?: string; // Coupon code
    is_fixed_amount?: string; // Is fixed amount
    is_percentage?: string; // Is percentage
    coupon_amount?: number; // Coupon amount
    coupon_percentage?: number; // Coupon percentage
    coupon_final_discount?: number; // Coupon final discount
    coupon_discount_amount?: number; // Price after coupon reduction
  };

  // Strip payment intent update
  payment_intent_id?: string;
}
